import React from 'react';
import PropTypes from 'prop-types';
import Add from 'material-ui/svg-icons/content/add';
import FormatListBulleted from 'material-ui/svg-icons/editor/format-list-bulleted';
import { primaryBlue } from '../../../../../theme/mainColors';
import TTDropZone from './ttDropZone/TTDropZone';

const iconsStyle = { height: 20, color: primaryBlue, marginTop: -3 };

class TTRowsOptions extends React.Component {
  constructor(props){
    super(props);
  }

  render() {
    const { onAddLineClick, onUploadListClick, style, onDropAccepted, disableDropZone } = this.props;
    return (
      <React.Fragment>
        <div className={ 'row-manager__row' } style={ style } onClick={ onAddLineClick }>
          <div>+ Add Another Line</div>
          <div><Add style={ iconsStyle } /></div>
        </div>
        <TTDropZone onDropAccepted={ onDropAccepted } disabled={ disableDropZone }>
          <div className={ 'row-manager__row' } style={ style } onClick={ onUploadListClick }>
            <div>+ Upload a List</div>
            <div><FormatListBulleted style={ iconsStyle } /></div>
          </div>
        </TTDropZone>
      </React.Fragment>
    );
  }
}

TTRowsOptions.propTypes = {
  onAddLineClick: PropTypes.func.isRequired,
  onUploadListClick: PropTypes.func,
  style: PropTypes.object,
  disableDropZone: PropTypes.bool,
  onDropAccepted: PropTypes.func.isRequired
};

TTRowsOptions.defaultProps = {
  style: { },
  disableDropZone: false,
  onUploadListClick: () => null
};

export default TTRowsOptions;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowsOptions/TTRowsOptions.js